import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelDynamic as _vModelDynamic, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "change-password-modal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "ChangePasswordModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header bg-secondary py-2 bg-gradient text-light" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "form-floating mb-3" }
const _hoisted_8 = {
  id: "validationOldPasswordFeedback",
  class: "invalid-feedback"
}
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "form-floating col" }
const _hoisted_11 = ["type"]
const _hoisted_12 = {
  id: "validationNewPasswordFeedback",
  class: "invalid-feedback"
}
const _hoisted_13 = { class: "form-floating mb-3" }
const _hoisted_14 = {
  id: "validationConfirmPasswordFeedback",
  class: "invalid-feedback"
}
const _hoisted_15 = {
  key: 0,
  id: "capslock-on",
  class: "text-warning small"
}
const _hoisted_16 = {
  id: "formErrorsFeedback",
  class: "invalid-feedback"
}
const _hoisted_17 = { class: "modal-footer justify-content-center" }
const _hoisted_18 = { class: "order-2" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "fas fa-spinner fa-spin fa-fw ms-1"
}
const _hoisted_21 = { class: "order-1" }
const _hoisted_22 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[12] || (_cache[12] = _createElementVNode("h5", { class: "modal-title" }, [
            _createElementVNode("i", { class: "fas fa-key fa-fw me-2" }),
            _createTextVNode(" Cambiar Contraseña ")
          ], -1)),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close btn-sm btn-close-white",
            "aria-label": "Close",
            ref: "close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, null, 512)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", {
            class: _normalizeClass({ 'is-invalid': _ctx.errors.includes('formError') }),
            "aria-describedby": "formErrorsFeedback",
            novalidate: ""
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "hidden",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.username) = $event)),
              id: "username"
            }, null, 512), [
              [_vModelText, _ctx.username]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "hidden",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userEmail) = $event)),
              id: "email"
            }, null, 512), [
              [_vModelText, _ctx.userEmail]
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.includes('oldPassword') }]),
                  id: "password",
                  ref: "password",
                  placeholder: "Contraseña anterior",
                  "aria-describedby": "validationOldPasswordFeedback",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.oldPassword) = $event)),
                  onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.typeOldPassword && _ctx.typeOldPassword(...args))),
                  required: ""
                }, null, 34), [
                  [_vModelText, _ctx.oldPassword]
                ]),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.invalidOldPasswordMessage), 1),
                _cache[13] || (_cache[13] = _createElementVNode("label", { for: "oldPassword" }, "Contraseña anterior", -1))
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: _normalizeClass(["input-group", { 'is-invalid': _ctx.errors.includes('newPassword') }])
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", {
                      type: _ctx.showPassword ? 'text' : 'password',
                      class: "form-control rounded-0 rounded-start",
                      id: "newPassword",
                      ref: "newPassword",
                      placeholder: "Contraseña nueva",
                      "aria-describedby": "validationNewPasswordFeedback",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newPassword) = $event)),
                      onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.validateNewPassword && _ctx.validateNewPassword(...args))),
                      required: ""
                    }, null, 40, _hoisted_11), [
                      [_vModelDynamic, _ctx.newPassword]
                    ]),
                    _cache[14] || (_cache[14] = _createElementVNode("label", { for: "password" }, "Contraseña nueva", -1))
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-outline-secondary pt-1",
                    type: "button",
                    id: "show-password",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fas fa-xs fa-fw", _ctx.showPassword ? 'fa-eye-slash' : 'fa-eye'])
                    }, null, 2)
                  ])
                ], 2),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.invalidNewPasswordMessage), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.includes('confirmPassword') }]),
                  id: "confirmPassword",
                  ref: "confirmPassword",
                  placeholder: "Confirmar Contraseña",
                  "aria-describedby": "validationConfirmPasswordFeedback",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                  onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.validateConfirmPassword && _ctx.validateConfirmPassword(...args))),
                  required: ""
                }, null, 34), [
                  [_vModelText, _ctx.confirmPassword]
                ]),
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.invalidConfirmPasswordMessage), 1),
                _cache[15] || (_cache[15] = _createElementVNode("label", { for: "confirmPassword" }, "Confirmar contraseña nueva", -1))
              ])
            ]),
            (_ctx.capsLockOn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[16] || (_cache[16] = [
                  _createElementVNode("span", { class: "small" }, [
                    _createElementVNode("i", { class: "fas fa-exclamation-triangle fa-fw me-1" }),
                    _createTextVNode(" BloqMayús (CapsLock) está activado. ")
                  ], -1)
                ]))]))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.formErrorMessage), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changePassword())),
              type: "button",
              class: "btn btn-outline-secondary mx-3 order-2",
              disabled: !_ctx.isValid || _ctx.saving
            }, [
              _cache[17] || (_cache[17] = _createTextVNode(" Aceptar ", -1)),
              (_ctx.saving)
                ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                : _createCommentVNode("", true)
            ], 8, _hoisted_19)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-primary mx-3 order-1",
              disabled: _ctx.saving,
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, " Cancelar ", 8, _hoisted_22)
          ])
        ])
      ])
    ])
  ]))
}